import React, { useEffect, useState } from "react";
import { useAuthState } from "../../../context/AuthContext";
import IconContentCard from "../../shared/IconContentCard";
import { FaCheckCircle, FaCommentDots, FaFileContract, FaFileInvoiceDollar, FaQuestion, FaUsers } from "react-icons/fa";
import { MdError, MdTroubleshoot, MdOutlineSummarize, MdEmergency } from "react-icons/md";
import { GiCardPick } from "react-icons/gi";
import { SiRobotframework } from "react-icons/si";
import { Button, Col, Form, Row } from "react-bootstrap";
import { BsBuildingsFill } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import ElvTicketStage from "./ElvTicketStage";
import BodyTicketStage from "./BodyTicketStage";
import UserTicketStage from "./UserTicketStage";
import BuildingTicketStage from "./BuildingTicketStage";
import SummaryTicketStage from "./SummaryTicketStage";
import AnlageTicketStage from "./AnlageTicketStage";
import InvoiceChoiceStage from "./InvoiceChoiceStage";
import PoolrechnungTicketStage from "./PoolrechnungTicketStage";
import LieferantrechnungTicketStage from "./LieferantrechnungTicketStage";
import EnergoTooltip from "../../shared/EnergoTooltip";

/**
 * 
 * @param {stage} props string passed from other pages to go to right stage direct
 */
const TicketHwComponent = (props) => {

    // * initial variable
    const {user, tooltips, tooltipsTrigger} = useAuthState();
    const {state} = useLocation();
    const [stage, setStage] = useState(props.stage || "default");
    const [apiError, setApiError] = useState("");
    const navigate = useNavigate();

    // * ticket variables
    const [ticketAbout, setTicketAbout] = useState("");
    const ticketsChoicesWithOptions = ["Energieliefervertrag", "Rechnung (ENERGO, Lieferantenrechnung)"];
    const ticketAboutRadios = ["Energieliefervertrag", "Rechnung (ENERGO, Lieferantenrechnung)", "Technisches Problem", "Sonstiges", "Notfall"];
    const [ticketBody, setTicketBody] = useState("");
    const [fileList, setFileList] = useState([]);
    const [selectedBuilding, setSelectedBuilding] = useState(null);
    const [selectedAnlage, setSelectedAnlage] = useState(null);
    const [selectedElvs, setSelectedElvs] = useState(null);
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");
    const [selectedUser, setSelectedUser] = useState(null);

    // * states
    const [buildingsState, setBuildingsState] = useState([]);
    const [anlagenState, setAnlagenState] = useState([]);
    const [usersState, setUsersState] = useState([]);
    const [elvsState, setElvsState] = useState([]);
    const [invoicesState, setInvoicesState] = useState([]);



    // * onload effect 
    useEffect(() => {
        if (state !== undefined && state !== null) {
            setSelectedElvs([state.object]);
            setTicketAbout('Energieliefervertrag');
            setStage("body");
        }
    }, [])

    // * stage effect
    useEffect(() => {
        // stage default reset all
        if (stage === "default") {
            if (state === undefined || state === null) {
                setTicketAbout("");
            }
        }
        if (stage === "buildings") {
            setSelectedBuilding(null);
        }
        if (stage === "anlagen") {
            setSelectedAnlage(null);
        }
        if (stage === "Energieliefervertrag") {
            setSelectedElvs(null);
        }
        if (stage === "Rechnung (ENERGO, Lieferantenrechnung)") {
            setSelectedInvoiceType("");
            setSelectedInvoices([]);
        }
        if (stage === "body") {
            setTicketBody("");
            setFileList([]);
        }
    }, [stage])


    // * GUI
    return (
        <IconContentCard
            variant={stage === "error"? "error" : null}
            icon={
                ticketAbout === "Energieliefervertrag" ? <FaFileContract size={50} /> :
                ticketAbout === "Rechnung (ENERGO, Lieferantenrechnung)" ? <FaFileInvoiceDollar size={50} /> :
                ticketAbout === "Technisches Problem" ? <MdTroubleshoot size={50} /> :
                ticketAbout === "Sonstiges" ? <FaQuestion size={50} /> :
                ticketAbout === "Notfall" ? <MdEmergency size={50} className="text-danger" />:
                stage === "buildings" ? <BsBuildingsFill size={50} /> :
                stage === "body" ? <FaCommentDots size={50} /> :
                stage === "users"? <FaUsers size={50} /> :
                stage === "faq" ? <SiRobotframework size={50} /> :
                stage === "summarize"? <MdOutlineSummarize size={50} /> :
                stage === "done" ? <FaCheckCircle size={50} /> :
                stage === "error"? <MdError size={50} />:
                <GiCardPick size={50} />
            }>
                {
                    stage === "default" ?
                        <>
                            <h5>Worum geht es bei Ihrem Anliegen?</h5>
                            <Row className="mt-4">
                                <Col xs="12" onChange={e => setTicketAbout(e.target.id)}>
                                    {ticketAboutRadios.map(radio => (
                                        <div style={{display: "flex"}}>
                                            <Form.Check className={radio === "Notfall"? "text-danger":null} key={radio} id={radio} type="radio" label={radio} name="aboutRadioGroup" style={{marginRight: 10}} />
                                            {tooltipsTrigger?
                                                radio === "Energieliefervertrag" ?
                                                    <EnergoTooltip tKey="7005" position="right" />:
                                                radio === "Rechnung (ENERGO, Lieferantenrechnung)" ?
                                                    <EnergoTooltip tKey="7006" position="right" /> :
                                                radio === "Technisches Problem" ?
                                                    <EnergoTooltip tKey="7007" position="right" /> :
                                                radio === "Sonstiges" ?
                                                    <EnergoTooltip tKey="7008" position="right" />:
                                                radio === "Notfall" ?
                                                    <EnergoTooltip tKey="7009" position="right" />
                                                :null
                                            :null}
                                        </div>
                                    ))}
                                </Col>
                            </Row>
                            <Row className="mt-5 text-end">
                                <Col xs="12">
                                    <Button 
                                        onClick={() => setStage(ticketAbout === "Energieliefervertrag"? "buildings" : ticketsChoicesWithOptions.includes(ticketAbout) ? ticketAbout : "body")}
                                        className="btn-energo"
                                        disabled={ticketAbout === ""}>Weiter</Button>
                                </Col>
                            </Row>
                        </>:

                    stage === "done" ? 
                        <>
                            <h5 className="text-energo">Ticket erstellt!</h5>
                            <Row className="mt-5">
                                <Col xs="12" className="text-center">
                                    <FaCheckCircle size={50} className="text-energo" /> <br /><br />
                                    <p>Vielen Dank für Ihre Anfrage. Wir haben Ihr Ticket bekommen und werden uns in Kürze bei Ihnen melden.</p>
                                </Col>
                            </Row>
                            <Row className="mt-5">
                                <Col xs="12" className="text-end">
                                    <Button
                                        className="btn-energo"
                                        onClick={() => setStage("default")}
                                        style={{marginRight: "5px"}}
                                    >Neues Ticket erstellen</Button>
                                    <Button
                                        className="btn-energo"
                                        onClick={() => navigate("/hw/dashboard/support/")}
                                    >Ticketübersicht</Button>
                                </Col>
                            </Row>
                        </> :
                    
                    stage === "error" ? 
                        <>
                            <h5 className="text-danger">Fehler aufgetreten</h5>
                            <Row className="mt-5 text-center">
                                <Col xs="12">
                                    <p>{apiError}</p>
                                </Col>
                            </Row>
                            <Row className="mt-5">
                                <Col xs="12" className="text-end">
                                    <Button onClick={() => setStage('summarize')} variant="warning">Zurück</Button>
                                </Col>
                            </Row>
                        </>
                    :
                    
                    stage === "body"?
                        <BodyTicketStage 
                            body={setTicketBody}
                            setFiles={setFileList}
                            about={ticketAbout} 
                            invoice={selectedInvoiceType} 
                            building={selectedBuilding}
                            setStage={setStage}
                            state={state}
                        /> :
                    stage === "users" ? 
                        <UserTicketStage 
                            state={usersState}
                            setState={setUsersState}
                            user={user} 
                            selectedUser={selectedUser} 
                            setSelectedUser={setSelectedUser} 
                            error={setApiError} 
                            setStage={setStage} 
                        />  :
                    stage === "summarize" ?
                        <SummaryTicketStage 
                            about={ticketAbout}
                            selectedUser={selectedUser}
                            user={user}
                            selectedBuilding={selectedBuilding}
                            selectedElvs={selectedElvs}
                            selectedInvoices={selectedInvoices}
                            selectedInvoiceType={selectedInvoiceType}
                            selectedAnlage={selectedAnlage}
                            body={ticketBody}
                            files={fileList}
                            setStage={setStage}
                            error={setApiError}
                        /> :
                    stage === "buildings" ?
                        <BuildingTicketStage 
                            state={buildingsState}
                            setState={setBuildingsState}
                            invoice={selectedInvoiceType} 
                            setStage={setStage} 
                            about={ticketAbout} 
                            setSelectedBuilding={setSelectedBuilding} 
                        /> :
                    stage === "anlagen" ?
                        <AnlageTicketStage 
                            state={anlagenState}
                            setState={setAnlagenState}
                            setSelectedAnlage={setSelectedAnlage} 
                            selectedBuilding={selectedBuilding} 
                            setStage={setStage}
                            error={setApiError}
                        /> :
                    stage === "Energieliefervertrag" ?
                        <ElvTicketStage
                            state={elvsState}
                            setState={setElvsState}
                            setSelectedElvs={setSelectedElvs} 
                            setStage={setStage} 
                            building={selectedBuilding} 
                            error={setApiError} 
                        /> :
                    stage === "Rechnung (ENERGO, Lieferantenrechnung)"?
                        <InvoiceChoiceStage 
                            setSelectedInvoices={setSelectedInvoices} 
                            selectedInvoices={selectedInvoices}
                            setStage={setStage} 
                            error={setApiError}
                        /> :
                    stage === "poolrechnung" ? 
                        <PoolrechnungTicketStage
                            setStage={setStage}
                            error={setApiError}
                            setSelectedInvoices={setSelectedInvoices}
                        /> :
                    stage === "energielieferant" ?
                        <LieferantrechnungTicketStage
                            setStage={setStage}
                            selectInvoices={setSelectedInvoices}
                        /> :
                    null
                }
            </IconContentCard>
    )
}

export default TicketHwComponent;